import React from 'react'

/**
 * @param table
 * @param isOwnTurn
 * @param send
 */
class TakePovertySelection extends React.Component
{

    handleSelectTakePoverty(take)
    {
        this.props.send({ type: "SELECT_TAKE_POVERTY", takePoverty: take })
    }

    render()
    {
        const t = this.props.table
        const povertyPlayer = t.get("players").find(p => p.get("bid") === "POVERTY")

        let content

        if (povertyPlayer.get("id") === t.get("ownId"))
        {
            content = (
                <div className="dk-box" style={{ textAlign: "center" }}>
                    { Messages("game.poverty.waiting") }
                </div>
            )
        }
        else
        {
            content = [
                <div key="h" className="dk-box">{ Messages("game.poverty.title", povertyPlayer.get("name"), t.get("povertyTrumpCount")) }</div>,
                <div key="c" className={ "options-container" }>
                    <div
                        key="y"
                        onClick={ () => this.handleSelectTakePoverty(true) } 
                        className={ "dk-box clickable option " + (this.props.isOwnTurn ? "" : "disabled") }>
                        { Messages("game.poverty.take") }
                    </div>
                    <div
                        key="n"
                        onClick={ () => this.handleSelectTakePoverty(false) } 
                        className={ "dk-box clickable option " + (this.props.isOwnTurn ? "" : "disabled") }>
                        { Messages("game.poverty.decline") }
                    </div>
                </div>
            ]
        }

        return (
            <div className="center-content">
                { content }
            </div>
        )
    }

}

export default TakePovertySelection
export { TakePovertySelection }